/**
 * Custom error class for HTTP errors that preserves trace ID from response headers.
 * Throw this from your query/mutation functions when a request fails.
 */
export class HttpError extends Error {
  public readonly traceId: string | null;
  public readonly status: number;

  constructor({
    message,
    status,
    traceId,
  }: {
    message: string;
    status: number;
    traceId: string | null;
  }) {
    super(message);
    this.name = "HttpError";
    this.status = status;
    this.traceId = traceId;
  }

  static async fromResponse(response: Response): Promise<HttpError> {
    let body;

    try {
      body = await response.json();
    } catch (e) {
      body = { message: await response.text() };
    }

    const message = body.error ?? body.message ?? response.statusText;

    return new HttpError({
      message,
      status: response.status,
      traceId: response.headers.get("X-Trace-Id"),
    });
  }
}
